<!-- <template>
  <div v-if="profileData">
    <div class="dovemed-card">
      <div>
        <p class="title text-uppercase">ABOUT {{ profileData.display_name }}</p>

        <p>
          <b>{{ "About" }} </b>:
          {{ profileData["about"] || "Yet to be added" }}
        </p>
        <div v-if="profileData.designation">
          <p>
            <b>{{ "Represent Organization" }} </b>:
            {{ profileData["represent_organization"] || "Yet to be added" }}
          </p>
          <p>
            <b>{{ "Designation" }} </b>:
            {{ profileData["designation"] || "Yet to be added" }}
          </p>
        </div>
        <div v-else>
          <p>
            <b>{{ "Represent Organization" }} </b>: My Self
          </p>
        </div>
        <p>
          <b>{{ "City" }} </b>:
          {{
            profileData["organization_location"][0].city || "Yet to be added"
          }}
        </p>

        <p>
          <b>{{ "Country" }} </b>:
          {{
            profileData["organization_location"][0].country || "Yet to be added"
          }}
        </p>
      </div>
    </div>
  </div>
</template> -->

<template>
  <div class="cont">
    <div class="about">
      <div class="header-cont">
        <span class="header">
          About
          <span class="text-capitalize">
            {{ viewUser.display_name }}
          </span>
        </span>
        <!-- <span  @click="() => $refs.editAboutModal.show(profileData)"
             :style="{background: getPrimary50Color() }" class="edit-button">
                    <font-awesome-icon
                            size="1x"
                            :style="{   color: getAlphaPrimaryColor50()}"
                            :icon="['fas', 'pen']"
                          />
                    <span :style="{ color: getPrimaryColor() }" class="button-text"> Edit</span>
          </span> -->
      </div>
      <div v-if="profileData && profileData.about" class="bio">
        <span class="bio" v-html="profileData && profileData.about ? profileData.about : 'Yet to be added'"></span>
      </div>
      <span v-else class="dailog1">Yet to be added</span>
    </div>
    <div class="org-cont">
      <div class="org">Supporting</div>
      <div v-if="profileData && profileData.represent_organization" class="tag">
        {{ profileData.represent_organization }}
      </div>
      <span v-else class="dailog2">Yet to be added</span>
    </div>
    <AboutModal ref="editAboutModal" v-on:refresh="fetchData" />
  </div>
</template>

<script>
import { RepositoryFactory } from "../../../../repositories/RepositoryFactory"

const UserRepository = RepositoryFactory.get("user")

export default {
  name: "AdvocateAbout",
  data() {
    return {
      keys: null,
      data: null,
      profileData: null,
      editableData: null,
      toDeleteKeys: ["id", "user", "story", "about"],
    }
  },
  created() {
    this.fetchData()
  },

  methods: {
    /**
     * Fetch user profile data
     */
    async fetchData() {
      const data = await UserRepository.getAbout(this.viewUser, this.currentCircle.id)
      this.profileData = data.data.data ? data.data.data[0] : {}
      let profileDataCopy = { ...this.profileData }
      this.toDeleteKeys.forEach(key => {
        delete profileDataCopy[key]
      })
      // const keys = Object.keys(profileDataCopy)
      const keys = Object.keys(profileDataCopy)
      this.cardKeys = this.makeKeys(keys)
      this.status = true
    },

    makeKeys(cardKeys) {
      let editableKeys = {}
      for (var key in cardKeys) {
        if (cardKeys.hasOwnProperty(key)) {
          editableKeys[cardKeys[key]] = false
        }
      }
      return editableKeys
    },
  },

  filters: {
    humanize: function(value, capitalize = true) {
      if (!value) return ""
      return capitalize
        ? value
            .toLowerCase()
            .split("_")
            .map(e => e.toUpperCase())
            .join(" ")
        : value
            .toLowerCase()
            .split("_")
            .map(e => e.charAt(0).toUpperCase() + e.substring(1))
            .join(" ")
    },

    total: function(value, ...options) {
      if (!value) return ""
      return Array.isArray(value) ? `(${value.length})` : ""
    },
  },
}
</script>

<style lang="scss" scoped>
.dailog1 {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  gap: 16px;
  height: 56px;
  background: #f1f5f9;
  border-radius: 8px;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #94a3b8;
  width: 100%;
}

.dailog2 {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  gap: 16px;
  height: 56px;
  background: #f1f5f9;
  border-radius: 8px;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #94a3b8;
  width: fit-content;
}
.org-cont {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.org {
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  color: #000000;
}

.tag {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 16px 24px;
  gap: 16px;
  height: 56px;
  background: #f1f5f9;
  border-radius: 6px;
  width: fit-content;
  text-transform: capitalize;
  font-family: "Lato";
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 24px;
  text-align: center;
  color: #1e2945;
}

.cont {
  display: flex;
  flex-direction: column;
  gap: 48px;
  width: 100%;
}
.about {
  display: flex;
  flex-direction: column;
  gap: 24px;
}
.bio {
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 32px;
  color: #647490;
  // white-space: pre-line;
  white-space: pre-wrap;
}
.button-text {
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 24px;
  cursor: pointer;
}
.edit-button {
  cursor: pointer;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 4px 16px;
  gap: 4px;
  // gap: 10px;
  width: 80px;
  height: 32px;
  border-radius: 8px;
}
.header-cont {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px;
  gap: 16px;
  // min-height: 5px;
  // margin-bottom: 24px;
  @media screen and (max-width: 700px) {
    width: 100%;
    min-height: 0px;
    margin-bottom: 0px;
  }
}

.header {
  font-style: normal;
  font-weight: 700;
  font-size: 32px;
  line-height: 42px;
  color: #0f1734;
  @media screen and (max-width: 600px) {
    font-size: 24px;
  }
}
.dovemed-icon-button {
  border-radius: 50%;
  font-size: 15px;
  border: none;
  width: 20px;
  height: 20px;
}

.dovemed-card {
  padding: 20px;
  background: #fff;
  border-radius: 8px;
  border: 1px solid #ccc;
  margin-bottom: 20px;

  .title {
    font-size: 18px;
    font-weight: bold;
  }
  ul {
    list-style: none; /* Remove default bullets */
  }

  ul li::before {
    content: "\2022";
    color: #21cde5;
    font-weight: bold;
    display: inline-block;
    width: 8px;
    height: 8px;
    margin-left: -1em;
  }

  .language {
    display: flex;
    margin-left: 20px;
    justify-content: space-between;
  }

  .mono-language {
    display: flex;
  }
}

//// old csss
.dovemed-icon-button {
  border-radius: 50%;
  font-size: 15px;
  border: none;
  width: 20px;
  height: 20px;
}

.dovemed-card {
  padding: 20px;
  background: #fff;
  border-radius: 8px;
  border: 1px solid #ccc;
  margin-bottom: 20px;

  .title {
    font-size: 18px;
    font-weight: bold;
  }
  ul {
    list-style: none; /* Remove default bullets */
  }

  ul li::before {
    content: "\2022";
    color: #21cde5;
    font-weight: bold;
    display: inline-block;
    width: 8px;
    height: 8px;
    margin-left: -1em;
  }

  .language {
    display: flex;
    margin-left: 20px;
    justify-content: space-between;
  }

  .mono-language {
    display: flex;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Users/Advocate/view/ViewAdvocateAbout.vue